exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "ul, ol {\n  list-style: none; }\n\nli {\n  background-color: #fff;\n  color: #000;\n  text-decoration: none;\n  padding: 5px 7px;\n  display: block; }\n\nul li:hover {\n  background-color: #3b5998;\n  color: #fff; }\n\nul {\n  height: 140px;\n  overflow-y: scroll; }\n\ntextarea {\n  height: 170px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/import-template/component/concat/concat.component.scss
// module id = 2027
// module chunks = 66